import React, { useEffect } from "react";
import { Container, Card } from "react-bootstrap";
import { RiAddFill, RiFileEditFill } from "react-icons/ri";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

import AppointmentRequestForm from "./forms/AppointmentRequestForm";
import AppointmentScheduledForm from "./forms/AppointmentScheduledForm";
import AppointmentCompletedForm from "./forms/AppointmentCompletedForm";
import RxRequestForm from "./forms/RxRequestForm";
import GeneralPatientRequestForm from "./forms/GeneralPatientRequestForm";
import OldGeneralPatientRequestForm from "./forms/OldGeneralPatientRequestForm";
import PatientCommunicationForm from "./forms/PatientCommunicationForm";
import InternalCommunicationForm from "./forms/InternalCommunicationForm";
import SpecialistReferralForm from "./forms/SpecialistReferralForm";
import * as CONST from "../helpers/Constants";
import * as API from "../api";
import PatientSearch from "./PatientSearch";
import Loading from "../shared/Loading";

const CreateTask = ({ state, dispatch }) => {
  let queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let patientId = urlParams.get('patient_id');
  let q = urlParams.get('task_type');
  let queryTaskType = q && q.replaceAll("_"," ");
  const [taskType, setTaskType] = React.useState(queryTaskType);
  const [loading, setLoading] = React.useState(false);
  const [isPatientSelected, setIsPatientSelected] = React.useState(patientId != null || patientId != undefined);
  const [skipSelectPatient, setSkipSelectPatient] = React.useState(false);

  let getPatient = async (patientId) => {
    const response = await API.getPatientByName(patientId);
    return response;
  };

  useEffect(async () => {
    if (patientId) {
      let response = await getPatient(patientId);
      taskAndPatientHandler(response.patients[0]);
    }
    state.create.type && setTaskType(state.create.type);
    dispatch({ type: "set_creating_task", payload: true });
    return () => {
      dispatch({ type: "set_creating_task", payload: false });
      setSkipSelectPatient(false);
      setIsPatientSelected(false);
    };
  }, []);

  const taskAndPatientHandler = (p) => {
    if (p.specialist_referrals_enabled != true && taskType == 'Specialist Referral') {
      if (p.eligible != true) {
        alert('The patient you selected is not eligible and cannot be sent specialist referrals. Please select another patient.');
      } else {
        alert('The patient you selected is in a health plan that does not have our specialist referral feature enabled. Please select another patient.');
      }
    } else {
      setIsPatientSelected(true);
      setLoading(true);
      dispatch({ type: "set_create_task", payload: { patient: p, type: taskType } });
      setTimeout(() => setLoading(false), 500);
    }
  };

  const FormWrapper = ({ form }) => (
    <Card className="create-task">
      <a
        className="go-back"
        style={{ textDecoration: "none" }}
        onClick={() => {
          setSkipSelectPatient(false);
          setIsPatientSelected(false);
          dispatch({
            type: "set_create_task",
            payload: {
              patient: "",
              create: "",
            },
          });
        }}
      >
        <FaArrowLeft style={{ marginBottom: "-2px", marginRight: "10px", fontSize: "1.2em" }} />
        Go Back
      </a>
      <div className="pad20">{form}</div>
    </Card>
  );

  function renderForms() {
    return (
      <>
        {!skipSelectPatient && !isPatientSelected && (
          <Card className="create-task">
            <Card.Header>
              <div className="content">
                <RiFileEditFill id="big-big-icon" />

                <div style={{ margin: "3em auto auto .2em" }}>
                  {"Create a New Task "}
                  {/* <RiAddFill id="create-new" style={{ marginLeft: "8px" }} /> */}
                </div>
              </div>
              <br />
            </Card.Header>
            <Card.Body>
              <Card.Title as="h4">{"Select task type"}</Card.Title>{" "}
              <select
                name="task_type"
                value={taskType ? taskType : ""}
                onChange={(e) => {
                  setTaskType(e.target.value);
                }}
              >
                {!taskType && <option value={""}>Select task type</option>}
                {CONST.TASK_TYPES.map((option, i) => (
                  <option key={i} value={option}>
                    {option}
                  </option>
                ))}
              </select>{" "}
              {taskType == "Internal Communication" && (
                <a
                  id="float-r"
                  style={{ textDecoration: "none", marginTop: "70px" }}
                  onClick={() => !skipSelectPatient && setSkipSelectPatient(true)}
                >
                  <b>
                    Skip this step & create task{" "}
                    <FaArrowRight style={{ marginLeft: " 2px", marginBottom: "-2px" }} />
                  </b>
                </a>
              )}
              {taskType !== null && (
                <PatientSearch taskHandler={(val) => taskAndPatientHandler(val)} />
              )}
            </Card.Body>
          </Card>
        )}
        {loading && <Loading message={""} />}
        {!loading && isPatientSelected && taskType && (
          <>
            <FormWrapper
              form={
                taskType == "Appointment Request" ? (
                  <AppointmentRequestForm
                    dispatch={dispatch}
                    state={{
                      create: state.create,
                      patient: state.create.patient,
                    }}
                  />
                ) : taskType == "Appointment Scheduled" ? (
                  <AppointmentScheduledForm
                    dispatch={dispatch}
                    state={{
                      create: state.create,
                    }}
                  />
                ) : taskType == "Appointment Completed" ? (
                  <AppointmentCompletedForm
                    dispatch={dispatch}
                    state={{
                      create: state.create,
                    }}
                    isCall={false}
                  />
                ) : taskType == "Patient Communication" ? (
                    <PatientCommunicationForm
                      dispatch={dispatch}
                      task={{
                        patient: state.create.patient,
                        isNew: true,
                        type: state.create.type,
                      }}
                      isCall={false}
                    />
                ) : taskType == "General Patient Request" && state.settings.referral_request_v2_enabled == true ? (
                  <GeneralPatientRequestForm
                    dispatch={dispatch}
                    state={state}
                    task={{
                      patient: state.create.patient,
                      isNew: true,
                      type: state.create.type,
                    }}
                    isCall={false}
                  />
                ) : taskType == "General Patient Request" && state.settings.referral_request_v2_enabled == false ? (
                  <OldGeneralPatientRequestForm
                    dispatch={dispatch}
                    state={state}
                    task={{
                      patient: state.create.patient,
                      isNew: true,
                      type: state.create.type,
                    }}
                    isCall={false}
                  />
                ) : taskType == "Rx Request" ? (
                  <RxRequestForm
                    dispatch={dispatch}
                    task={{
                      patient: state.create.patient,
                      isNew: true,
                      type: state.create.type,
                    }}
                    isCall={false}
                  />
                ) : taskType == "Internal Communication" &&
                !skipSelectPatient ? ((
                    <InternalCommunicationForm
                      dispatch={dispatch}
                      task={{
                        patient: state.create.patient,
                        isNew: true,
                        type: state.create.type,
                      }}
                      isCall={false}
                    />
                  )
                ) : (
                  taskType == "Specialist Referral" && state.settings.specialist_types && (
                    <SpecialistReferralForm
                      state={state}
                      dispatch={dispatch}
                      task={{
                        patient: state.create.patient,
                        isNew: true,
                        type: state.create.type,
                      }}
                      isCall={false}
                    />
                  )
                )
              }
            />
          </>
        )}
        {!loading &&
          !isPatientSelected &&
          skipSelectPatient &&
          taskType == "Internal Communication" && (
            <FormWrapper
              form={
                <InternalCommunicationForm
                  dispatch={dispatch}
                  task={{
                    isNew: true,
                    patient: { id: null },
                    type: state.create.type,
                  }}
                  isCall={false}
                />
              }
            />
          )}
      </>
    );
  }

  return <Container className=" task">{renderForms()}</Container>;
};

export default CreateTask;
